import { Grid } from "@mui/material";
import { AquariusIconButton } from "@smartrr/shared/customerPortal/components/AquariusIconButton";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { useMobileQuery } from "@customer-app/account/views/OperationAquarius/utils";

import { useModalButtonOptions } from "../../../../../Modals/ManageSubscriptionsModal/hooks/useModalButtonOptions";
import { ValidViews } from "../../../../../Modals/OrderOptionsModalInner";
import { IActionButtonProps } from "../../../types";

export const ActionButtons = ({ delivery, isPaused, onSelectModalView }: IActionButtonProps) => {
  const isMobile = useMobileQuery();

  const activeActions: ValidViews[] = ["Order now", "Skip", "Delay date"];

  const buttonOptions = useModalButtonOptions(delivery, "orderOptions");

  if (isPaused) {
    return <React.Fragment />;
  }

  return (
    <Grid
      container
      justifyContent={isMobile ? "space-around" : "end"}
      gap="15px"
      sx={{
        span: {
          fontWeight: "400",
        },
        "& .MuiGrid-item": {
          width: "80px",
        },
      }}
      data-testid="action-buttons-row"
    >
      {buttonOptions
        .filter(action => activeActions.includes(action.view))
        .map((action, index) => (
          <Grid item key={index} id={`modal-action-${action?.label}`}>
            <AquariusIconButton
              data-testid={`icon-button-${action?.label!}`}
              iconName={action?.iconName!}
              size="large"
              onClick={() => onSelectModalView("ORDER_OPTIONS", { initialView: action.view })}
              label={localize(`customerActions.${action?.label}`)}
            />
          </Grid>
        ))}
    </Grid>
  );
};
